/* eslint-disable */

import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const EmoticonFieldOption = ({ onInputChange, value, checked }) => (
  <label
    className={classnames("emoticon-option", {
      "emoticon-option--checked": checked,
    })}
  >
    <input
      name="emoticon"
      className="emoticon-option__input"
      type="radio"
      value={value}
      checked={checked}
      onChange={(e) => onInputChange(e.target.name, e.target.value)}
    />
    <img
      className="emoticon-option__image"
      alt=""
      src={`/themes/custom/drupack/resources/components/comments/avatars/${value}.gif`}
    />
  </label>
);

EmoticonFieldOption.propTypes = {
  value: PropTypes.string.isRequired,
  onInputChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
};

/* eslint-disable jsx-a11y/label-has-for */
const EmoticonField = ({ onInputChange, value }) => {
  const result = [];
  for (let i = 1; i <= 7; i++) {
    result.push(
      <EmoticonFieldOption
        onInputChange={onInputChange}
        value={+i}
        checked={+value === i}
      />
    ); // eslint-disable-line max-len
  }

  return (
    <fieldset className="form-item form-item--emoticon">
      <legend className="form-label form-required">Jouw mood:</legend>
      <div className="emoticons">{result}</div>
    </fieldset>
  );
};

EmoticonField.propTypes = {
  value: PropTypes.string.isRequired,
  onInputChange: PropTypes.func.isRequired,
};

EmoticonField.defaultProps = {
  value: "",
};

export default EmoticonField;
